import { Component } from '@angular/core';

@Component({
  selector: 'com-drawer-loader',
  styleUrls: ['loader.component.scss'],
  templateUrl: './loader.component.html'
})
export class DrawerLoaderComponent {}
